import { Radio } from 'antd';
import { INVOICE_AMOUNT_CHECK_OPTIONS, type InvoiceAmountCheck } from '@salaries/shared';

// Whether an uploaded חשבונית's amount is verified against the salary owed.
// Lives inside the חשבוניות settings card, under the collection policy — it only
// means anything when the box actually collects invoices, so the card hides it
// when the policy is 'none'. Shape mirrors InvoicePolicyField.
export function InvoiceAmountCheckField({
  value,
  onChange,
}: {
  value?: InvoiceAmountCheck;
  onChange?: (v: InvoiceAmountCheck) => void;
}) {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange?.(e.target.value as InvoiceAmountCheck)}
      className="w-full"
    >
      <div className="flex flex-col gap-2">
        {INVOICE_AMOUNT_CHECK_OPTIONS.map((o) => (
          <Radio key={o.value} value={o.value} className="items-start py-1">
            <div className="text-main-text">{o.label}</div>
            <div className="text-small text-secondary-text">{o.desc}</div>
          </Radio>
        ))}
      </div>
    </Radio.Group>
  );
}
